import createVueApp from '../shared/vue/create-app';
import {initLoginComponents} from './login';
import initGaTrackerComponent from './ga-tracking';
import {globalActions} from '../store/global-actions';
import {store} from '../store/global-store';
import axios from 'axios';
import initCustomControls from './custom-controls';
import initCookeBaseTimerControls from './cookie-based-timer';
import initChatComponents from './chat';
import initCustomInputsComponents from './inputs/custom-inputs';
import initEmailInput from './inputs/email-input';
import initMarkdownViewerComponent from './markdown/markdown-viewer';
import initListingStatisticsComponent from './listing-statistics';

function initVueGlobalComponents(options) {
    const app = createVueApp({
        data() {
            return {
                showBoostModal: false,
                showUpdatedModal: false,
                createOrderUrl: '',
            };
        },
        methods: {
            // TODO: Rewrite without $root in html and these methods in every page instance
            openReportModal(listingId, reportType, listingType) {
                globalActions.openReportModal({targetId: listingId, reportType, listingType});
            },
            raiseRelevance(raiseRelevanceUrl, createOrderUrl) {
                axios.post(raiseRelevanceUrl).then(() => {
                    this.showUpdatedModal = true;
                    this.createOrderUrl = createOrderUrl;
                });
            },
            showOnMap(listingId, url) {
                window.location = url;
            },
            subscribeOpenModals() {
                store.subscribe((mutation) => {
                    if (mutation.type === 'openBoostModal') {
                        this.showBoostModal = true;
                    }
                });
            },
            setRegistrationPlaces() {
                globalActions.setCommentRegistrationPlace(options.commentRegistrationPlace);
                globalActions.setMessageRegistrationPlace(options.messageRegistrationPlace);
                globalActions.setRateRegistrationPlace(options.rateRegistrationPlace);
            },
        },
        mounted() {
            this.setRegistrationPlaces();
            this.subscribeOpenModals();
        },
    });

    initLoginComponents(app);
    initGaTrackerComponent(app);
    initCustomControls(app);
    initCookeBaseTimerControls(app);
    initChatComponents(app);
    initCustomInputsComponents(app);
    initEmailInput(app);
    initMarkdownViewerComponent(app);
    initListingStatisticsComponent(app);

    app.mount(options.el);

    return app;
}


export {initVueGlobalComponents};
